import baterie from "$lib/images/category/baterie.png";
import blinkry from "$lib/images/category/blinkry.png";
import cisteni from "$lib/images/category/cisteni.png";
import dily_na_vyfuk from "$lib/images/category/dily_na_vyfuk.png";
import gripy from "$lib/images/category/gripy.png";
import gufera from "$lib/images/category/gufera.png";
import helmy from "$lib/images/category/helmy.png";
import kapaliny from "$lib/images/category/kapaliny.png";
import karburatory2t from "$lib/images/category/karburatory2t.png";
import karburatory4t from "$lib/images/category/karburatory4t.png";
import kufry from "$lib/images/category/kufry.png";
import lanka from "$lib/images/category/lanka.png";
import loziska from "$lib/images/category/loziska.png";
import obleceni from "$lib/images/category/obleceni.png";
import oleje from "$lib/images/category/oleje.png";
import palivova_soustava from "$lib/images/category/palivova_soustava.png";
import samolepky from "$lib/images/category/samolepky.png";
import srouby from "$lib/images/category/srouby.png";
import svicky from "$lib/images/category/svicky.png";
import trysky from "$lib/images/category/trysky.png";
import uni_brzdy from "$lib/images/category/uni_brzdy.png";
import uni_doplnky from "$lib/images/category/uni_doplnky.png";
import uni_elektro from "$lib/images/category/uni_elektro.png";
import uni_naradi from "$lib/images/category/uni_naradi.png";
import valecky from "$lib/images/category/valecky.png";
import vzduchove_filtry from "$lib/images/category/vzduchove_filtry.png";
import zabezpeceni from "$lib/images/category/zabezpeceni.png";
import zarovky from "$lib/images/category/zarovky.png";
import zrcatka from "$lib/images/category/zrcatka.png";
import pneumatiky from "$lib/images/category/pneumatiky.png";
import all from "$lib/images/category/all.png";
import brzdy from "$lib/images/category/brzdy.png";
import dily from "$lib/images/category/dily.png";
import elektro from "$lib/images/category/elektro.png";
import kapotaz from "$lib/images/category/kapotaz.png";
import motor from "$lib/images/category/motor.png";
import naradi from "$lib/images/category/naradi.png";
import originalnidily from "$lib/images/category/originalni-dily.png";
import osvetleni from "$lib/images/category/osvetleni.png";
import styl from "$lib/images/category/styl.png";
import uni_all from "$lib/images/category/uni_all.png";
import variator from "$lib/images/category/variator.png";
import vyfuk from "$lib/images/category/vyfuk.png";
import ventilky from "$lib/images/category/ventilky.png";

export const resolveImageByUrl = (category: string | any) => {
    switch (category.url) {
        case 'baterie':
            return baterie;
        case 'blinkry':
            return blinkry;
        case 'cisteni':
            return cisteni;
        case 'dily_na_vyfuk':
            return dily_na_vyfuk;
        case 'gripy':
            return gripy;
        case 'gufera':
            return gufera;
        case 'helmy':
            return helmy;
        case 'kapaliny':
            return kapaliny;
        case 'karburatory2t':
            return karburatory2t;
        case 'karburatory4t':
            return karburatory4t;
        case 'kufry':
            return kufry;
        case 'lanka':
            return lanka;
        case 'loziska':
            return loziska;
        case 'obleceni':
            return obleceni;
        case 'oleje':
            return oleje;
        case 'palivova_soustava':
            return palivova_soustava;
        case 'samolepky':
            return samolepky;
        case 'srouby':
            return srouby;
        case 'svicky':
            return svicky;
        case 'trysky':
            return trysky;
        case 'uni_brzdy':
            return uni_brzdy;
        case 'uni_doplnky':
            return uni_doplnky;
        case 'uni_elektro':
            return uni_elektro;
        case 'uni_naradi':
            return uni_naradi;
        case 'valecky':
            return valecky;
        case 'vzduchove_filtry':
            return vzduchove_filtry;
        case 'zabezpeceni':
            return zabezpeceni;
        case 'zarovky':
            return zarovky;
        case 'zrcatka':
            return zrcatka;
        case 'pneumatiky':
            return pneumatiky;
        case 'all':
            return all;
        case 'brzdy':
            return brzdy;
        case 'dily':
            return dily;
        case 'elektro':
            return elektro;
        case 'kapotaz':
            return kapotaz;

        case 'motor':
            return motor;
        case 'naradi':
            return naradi;
        case 'originalni':
            return originalnidily;
        case 'osvetleni':
            return osvetleni;
        case 'styl':
            return styl;
        case 'uni_all':
            return uni_all;
        case 'variator':
            return variator;
        case 'vyfuk':
            return vyfuk;
        case 'ventilky':
            return ventilky;
        default:
            return `https://www.scootland.cz/static/img/category/${category.url}.png`;
    }
}

export const resolveImageByUrlString = (category: string | any) => {
    switch (category) {
        case 'baterie':
            return baterie;
        case 'blinkry':
            return blinkry;
        case 'cisteni':
            return cisteni;
        case 'dily_na_vyfuk':
            return dily_na_vyfuk;
        case 'gripy':
            return gripy;
        case 'gufera':
            return gufera;
        case 'helmy':
            return helmy;
        case 'kapaliny':
            return kapaliny;
        case 'karburatory2t':
            return karburatory2t;
        case 'karburatory4t':
            return karburatory4t;
        case 'kufry':
            return kufry;
        case 'lanka':
            return lanka;
        case 'loziska':
            return loziska;
        case 'obleceni':
            return obleceni;
        case 'oleje':
            return oleje;
        case 'palivova_soustava':
            return palivova_soustava;
        case 'samolepky':
            return samolepky;
        case 'srouby':
            return srouby;
        case 'svicky':
            return svicky;
        case 'trysky':
            return trysky;
        case 'uni_brzdy':
            return uni_brzdy;
        case 'uni_doplnky':
            return uni_doplnky;
        case 'uni_elektro':
            return uni_elektro;
        case 'uni_naradi':
            return uni_naradi;
        case 'valecky':
            return valecky;
        case 'vzduchove_filtry':
            return vzduchove_filtry;
        case 'zabezpeceni':
            return zabezpeceni;
        case 'zarovky':
            return zarovky;
        case 'zrcatka':
            return zrcatka;
        case 'pneumatiky':
            return pneumatiky;
        case 'all':
            return all;
        case 'brzdy':
            return brzdy;
        case 'dily':
            return dily;
        case 'elektro':
            return elektro;
        case 'kapotaz':
            return kapotaz;
        case 'ventilky':
            return ventilky;
        case 'motor':
            return motor;
        case 'naradi':
            return naradi;
        case 'originalni':
            return originalnidily;
        case 'osvetleni':
            return osvetleni;
        case 'styl':
            return styl;
        case 'uni_all':
            return uni_all;
        case 'variator':
            return variator;
        case 'vyfuk':
            return vyfuk;
        default:
            return `https://www.scootland.cz/static/img/category/${category.url}.png`;
    }
}
